import Api from "./Api"
import { API_VERSION } from "@/config/index"

export default {
    GetCinemas(payload={}) {
        let query = "";
        if (Object.keys(payload).length > 0) {
            let urlparams = new URLSearchParams();
            for(const key in payload) {
                if(payload[key]) {
                    urlparams.append(key, payload[key]);
                }
            }
            if([...urlparams.entries()].length > 0) {
                query += `?${urlparams.toString()}`;
            }
            // query += `?search=${payload.search}`;
        }
        return Api().get(`/admin/cinemas/${query}`)
        // return Api().get(`/${API_VERSION}/admin/cinemas`)
    },
    GetCinemaDetails(payload) {
        return Api().get(`/admin/cinemas/${payload.cinema_code}`)
        // return Api().get(`/${API_VERSION}/admin/cinemas/${payload.cinema_code}`)
    },
    AddCinemaDetails(payload) {
        return Api().post(`/admin/cinemas/`, payload)
        // return Api().post(`/${API_VERSION}/admin/cinemas/${payload.cinema_code}`, payload)
    },
    EditCinemaDetails(payload) {
        return Api().put(`/admin/cinemas/${payload.cinema_code}`, payload)
        // return Api().put(`/${API_VERSION}/admin/cinemas/${payload.cinema_code}`, payload)
    },
    GetCinemaClassification(payload) {
        return Api().get(`/admin/cinemas/classification`)
        // return Api().put(`/${API_VERSION}/admin/cinemas/${payload.cinema_code}`, payload)
    }
}


